import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { ApiService } from 'src/services/api.service';

@Component({
  selector: 'app-receipt-link',
  template: '<div class="bg-white p-5 text-center">Loading receipt search...</div>'
})
export class ReceiptLinkComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private apiService: ApiService
  ) {}

  async ngOnInit(): Promise<void> {
    const customerNumber = this.route.snapshot.paramMap.get('customerNumber');
    if (customerNumber != null) {
      const customerId = await firstValueFrom(this.apiService.getCustomerIdFromNumber(customerNumber));
      await this.router.navigate(['/customer', customerId.id], { queryParams: { receiptSearch: 'true' } });
      return;
    }

    console.error('No customer number found in URL');
    await this.router.navigate(['/']);
  }
}
